import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const VideoCoursesProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `FranchiseVideos/Get/${props.Id}`, method: 'GET', secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `FranchiseVideos/UpdateNationalFranchiseVideoCourse/${props.Id}`, method: 'PUT', payload: props, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: 'FranchiseVideos/GetNationalFranchiseVideoCourses', method: 'GET', secure: true });
    }, [execute]);  

    const value = { selectRecord, listRecords, updateRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useVideoCoursesStore = () => React.useContext(Context);
